import React from 'react';
import { ClaimsCardContent } from './ReturnsCardContent';
import { USER_TYPE } from '../../constants';
import {
  ClaimOverviewWithReturnsDto,
  PaymentInfo,
  ReturnEntries,
} from '../../../../../typings/returns';

import S from './style/ReturnsCard';

interface ClaimsCardProps {
  returnItem: ReturnEntries;
  claimItem: ClaimOverviewWithReturnsDto;
  onAdPreviewClick?: (returnId: string) => void;
  onFillDataClick: (returnId: string, userType: USER_TYPE) => void;
  isDesktop: boolean;
  showReturnsTransactionInfo: boolean;
  refetch?: PaymentInfo;
}

export const ReturnsCard: React.FC<ClaimsCardProps> = props => (
  <S.ReturnsCardContainer data-cy="return-item-card">
    <ClaimsCardContent {...props} />
  </S.ReturnsCardContainer>
);
